import parse, { DOMNode, Element as DomElement } from "html-react-parser";
import { ReactNode } from "react";

const shouldStripNode = (node: DOMNode) => {
  if (node.type === "script") return true;

  if (node.type === "tag") {
    const element = node as DomElement;
    if (element.name?.toLowerCase() === "script") return true;

    const src = element.attribs?.src || "";
    if (src.includes("wiris.net")) return true;
  }

  return false;
};

export const safeParseHtml = (html?: string): ReactNode | null => {
  if (!html) return null;

  return parse(html, {
    replace: (node) => (shouldStripNode(node) ? null : undefined),
  });
};

